app.controller('designchoicesController', function (
    $scope,
    $state,
    objectService,
    questionService,
    designLineService,
    $uibModal
) {

    if(objectService.currentConfigId && objectService.currentConfigId >= 177 ){
        if(!objectService.currentPresetId) {
            objectService.changeDesignLine(1);
        }

        $state.go('design');
    } else {
        $scope.designLines = designLineService.designLines;
        $scope.selectedDesignLine = objectService.getSelectedDesignLine();

        if (!designLineService.designLines.length) {
            $state.go('preloader');
        }
    }

    $scope.pluralize = {
        'du_ni': objectService.buyers.length > 1 ? 'ni' : 'du',
        'din_er': objectService.buyers.length > 1 ? 'er' : 'din',
        'dina_era': objectService.buyers.length > 1 ? 'era' : 'dina',
    };

    function executeSelection(designLineId){
        objectService.changeDesignLine(designLineId)
        $state.go('design');
    }

    function confirmSelection(designLineId){
        $uibModal.open({
            animation: true,
            templateUrl: 'partials/designchoices/confirm_modal.html',
            controller: ['$scope',function($scope){
                $scope.confirm = function(){
                    executeSelection(designLineId);
                    $scope.$close();
                };
            }],
        });
    }

    $scope.select = function($event, designLineId, restart){
        $event.stopPropagation();
        if(!!$scope.selectedDesignLine && $scope.selectedDesignLine.id == designLineId && !restart){
            $state.go('design');
        } else if($scope.selectedDesignLine) {
            confirmSelection(designLineId);
        } else {
            executeSelection(designLineId);
        }
    };
});
